import {
  Flex,
  Box,
  Text,
  Button,
  Input,
  Stack,
  HStack,
} from '@chakra-ui/react';
import { COLORS as COLORS_TYPE } from '../../constant';
import { SubSectionHeading } from '../../shared/Typography';

interface ApplicationNameSectionProps {
  localEnabled: boolean;
  getBrandDisplayName: () => string;
  isEditingName: boolean;
  setIsEditingName: (editing: boolean) => void;
  editedName: string;
  setEditedName: (name: string) => void;
  COLORS: typeof COLORS_TYPE;
}

export type { ApplicationNameSectionProps };

export function ApplicationNameSection({
  localEnabled,
  getBrandDisplayName,
  isEditingName,
  setIsEditingName,
  editedName,
  setEditedName,
  COLORS,
}: ApplicationNameSectionProps) {
  return (
    <Stack fontSize="14px" px="24px" pt="16px" pb="24px">
      <Flex width="100%" gap={16} alignItems="flex-start">
        <Box flex={1} minWidth={0}>
          <SubSectionHeading as="h3" fontSize="14px" pb="2">
            Connect Display Name
          </SubSectionHeading>
          <HStack justify="space-between" align="start" flexWrap="wrap">
            <Text color={COLORS.GRAY.GRAY_600}>
              With Branding turned {localEnabled ? 'on' : 'off'}, your
              application name shows in Finch Connect as{' '}
              <b>{getBrandDisplayName()}</b>.
            </Text>
            <Button
              variant="link"
              colorScheme="blue"
              alignSelf="flex-start"
              mt={2}
              onClick={() => {
                setIsEditingName(true);
                setEditedName('');
              }}
              style={{ padding: 0, height: 'auto' }}
            >
              Change Connect Display Name
            </Button>
          </HStack>
        </Box>
        <Box flex={1} minWidth={0}>
          <SubSectionHeading as="h3" fontSize="14px" pb="2">
           Current Connect Display Name
          </SubSectionHeading>
          <HStack justify="space-between" align="start" flexWrap="wrap">
            <Input
              value={getBrandDisplayName()}
              isDisabled
              mb={isEditingName ? 2 : 0}
              _disabled={{ bg: COLORS.GRAY.GRAY_200, cursor: 'not-allowed' }}
            />
            {isEditingName && (
              <>
                <SubSectionHeading as="h3" fontSize="14px">
                  New Connect Display Name
                </SubSectionHeading>
                <Input
                  value={editedName}
                  onChange={(e) => setEditedName(e.target.value)}
                  autoFocus
                  mb={1}
                  borderColor={
                    editedName.length > 50 ? COLORS.FINCH.ERROR_RED : undefined
                  }
                  _focus={{
                    borderColor:
                      editedName.length > 50
                        ? COLORS.FINCH.ERROR_RED
                        : undefined,
                  }}
                />
                <Box width="100%">
                  <Text
                    fontSize="xs"
                    color={
                      editedName.length > 50
                        ? COLORS.FINCH.ERROR_RED
                        : editedName.length >= 38
                        ? COLORS.ORANGE
                        : COLORS.GRAY.GRAY_600
                    }
                    backgroundColor={
                      editedName.length > 50
                        ? COLORS.LIGHT_RED
                        : editedName.length >= 38
                        ? COLORS.YELLOW_LIGHT
                        : COLORS.GRAY.GRAY_100
                    }
                    borderRadius="8px"
                    px={2}
                    width="fit-content"
                    ml="auto"
                    textAlign="right"
                  >
                    {50 - editedName.length}/50
                  </Text>
                </Box>
              </>
            )}
          </HStack>
        </Box>
      </Flex>
    </Stack>
  );
}
